<template>
  <div>
    <!-- 操作指南 -->
    <div class="jc-one">
      <!-- 第一块 -->
      <el-row>
        <el-col :span="20">
          <div style="line-height: 50px">
            <el-row><el-col :span="20"
                      :offset="1">
                <span style="font-size: 38px">主要功能介绍</span>
              </el-col></el-row>
            <el-row><el-col :span="20"
                      :offset="1">在右上角的菜单栏，可以看到 主页，教程，分类，个人中心等</el-col></el-row>
            <el-row><el-col :span="20"
                      :offset="1">1.<b style="color:rgb(44,62,80)">主页</b>包含了星系马戏团、公众科学的简介、星系马戏团搜寻达人排行，以及近期新闻</el-col></el-row>
            <el-row><el-col :span="20"
                      :offset="1">2.<b style="color:rgb(44,62,80)">教程</b>部分的星系马戏团、公众科学介绍，该网站的操作指南和已发现目标可以帮助您快速了解我们</el-col></el-row>
            <el-row><el-col :span="20"
                      :offset="1">3.进入<b style="color:rgb(44,62,80)">分类</b>页面开始星系马戏团分类</el-col></el-row>
            <el-row><el-col :span="20"
                      :offset="1">4.可以进入 <b style="color:rgb(44,62,80)">个人中心</b> 查看历史记录</el-col></el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 第二块 -->
      <el-row>
        <!-- 第一列 -->
        <el-col :span="11">
          <div style="line-height: 50px; margin-top: 45px">
            <el-row><el-col :span="23"
                      :offset="1">
                <span style="font-size: 38px">星系马戏团分类教程</span>
              </el-col></el-row>
            <el-row><el-col :span="24"
                      :offset="1">1.首先你需要<b style="color:rgb(44,62,80)">点击</b>选中图片才能开始分类以及提示</el-col></el-row>
            <el-row><el-col :span="24"
                      :offset="1">2.接下来，在网页给出的数据内为每个类别选择数据，单点预选(选中状态下再次点击取消预选)，每类图片分别有一种代表颜色，与 <b>按钮</b> 的颜色相对应。(详细的类别说明在教程中定义)</el-col></el-row>
            <el-row><el-col :span="24"
                      :offset="1">3.然后，每次将一类或相似数据选择完成后,<b>点击</b>相应的类别按钮，并确定。这样可以将所选的数据归类到相应的类别中。</el-col></el-row>
            <el-row><el-col :span="24"
                      :offset="1">4.最后，在完成数据分类后，点击<b>提交</b>按钮以完成整个分类过程。 注意事项：</el-col></el-row>
            <el-row><el-col :span="24"
                      :offset="1">(1).分类图片总数必须大于等于<b>12张</b>才可以提交</el-col></el-row>
            <el-row><el-col :span="24"
                      :offset="1">(2).如果你在分类过程中选择错误，可以<b>双击</b>图片，撤销相应图片的选择。</el-col></el-row>
            <el-row><el-col :span="24"
                      :offset="1">(3).你选择多张图片提示只会提示<b>最后</b>一张概率并且有<b>红色</b>框高亮。</el-col></el-row>
          </div>
        </el-col>

        <el-col :span="13">
          <div class="tu">
            <img src="../assets/jc.jpg"
                 alt="">
          </div>
        </el-col>
      </el-row>
      <!-- 第三块 -->
      <el-row>
        <el-col>
          <div style="margin-top: 35px;margin-left:15px">
            <span style="font-size: 38px">详细介绍及视频教程请 <a href=""
                 style="color: rgb(161, 162, 165)">点击</a>
            </span>
          </div>
        </el-col>
      </el-row>
      <!-- 第四块 -->
      <!-- <el-row><el-col></el-col></el-row> -->
    </div>

    <!-- 回到顶部 -->
    <el-backtop :visibility-height="50"
                :bottom="120">
    </el-backtop>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.jc-one {
  color: rgb(44, 62, 80);
}
.tu {
  text-align: center;
  padding-left: 70px;
  padding-top: 300px;
  img {
    width: 100%;
    height: auto;
  }
}
</style>